var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-wrapper"},[_c('video',{ref:"video",attrs:{"playsinline":"","autoplay":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.videoWebm,"type":"video/webm"}}),_vm._v(" "),_c('source',{attrs:{"src":_vm.videoMp4,"type":"video/mp4"}}),_vm._v("\n\t\t"+_vm._s(_vm.videoFallbackText)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }